import React, {
  useEffect,
  useLayoutEffect,
  useReducer,
  useRef,
  useState
} from 'react';
import { connect } from 'react-redux';
import {
  AcceptButtonContainer,
  AddPhone,
  CreateContainer,
  CreateLeadForm,
  DownloadRow,
  DownloadSection,
  ExistingLead,
  GoBackContainer,
  PhoneSection,
  Row,
  TitleContainer,
  VehicleContent,
  VehicleSection,
  MaxHeightBox
} from './style';
import MainFont from '../../typography/mainFont';
import { Button, Checkbox, DropDown, Icon, Input, Textarea } from 'ui/atoms';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { push } from 'redux-first-history';
import theme from '../../theme';
import { CHECK_LEAD_CREATION, CREATE_LEAD_B2C } from 'redux/sagas/actions/lead';
import phonePrefixesSalesforce from '../../../utils/phonePrefixesSalesforce';
import { RegexpType, validator } from '../../../utils/validator';
import CloseLeadCreation from './CloseLeadCreation';
import { SpinnerIcon } from '../../atoms/Table/style';
import spinnerIcon from '../../assets/img/spinner-icon.png';
import { RESET_CHECK_DATA } from '../../../redux/slices/lead';
import routes from '../../../routing/routes';
import spinnerIconWhite from '../../assets/img/spinner-icon-white.png';
import { initialState, reducer } from './b2cReducer';
import { loadCorrectDoc, loadCorrectPdf } from 'api/helpers/lead';
import { brandsVehicle } from 'const';

export const existingLead = (errorCheckAPI, existingLeadId, pushUrl, t) => (
  <>
   {errorCheckAPI ? (
  existingLeadId ? (
    <>
      <ExistingLead
        onClick={() => {
          pushUrl(`${routes.lead.path}/${existingLeadId}`);
        }}
      >
        <MainFont type="errorLabelLink">
          {t('error_lead_creation_first_part')}
        </MainFont>{' '}
      </ExistingLead>
      <MainFont type="errorLabel">
        {t('error_lead_creation_second_part')}
      </MainFont>
    </>
  ) : (
    <div>
      <MainFont type="errorLabel">
        {t('error_lead_creation_full')}
      </MainFont>
    </div>
  )
) : null}
  </>
);

export const DropDownSelectPreference = (dispatch, t) => (
  <>
   <MainFont type="description">{t('product_preference')}</MainFont>
            <Row noFlex>
              <DropDown
                options={[
                  { value: 'Prospect_vente borne et installation non effectuée', label: t('Prospect_vente borne et installation non effectuée') },
                  { value: 'Client_vente borne et installation effectuée via bon de commande', label: t('Client_vente borne et installation effectuée via bon de commande') }
                ]}
                onChange={selection => {
                  dispatch({
                    type: 'set_product_interest',
                    payload: selection
                  });
                }}
                isMulti
                detachedOptions
                variant="editaccountdata"
                placeholder={`${t('product_preference')}*`}
              />
            </Row>
  </>
);

const CreateLeadB2C = ({
  resetLeadType,
  createLeadB2C,
  isLoading,
  checkLeadCreation,
  checkWasDone,
  errorCheckAPI,
  resetCheckData,
  productOfInterest,
  callbackOnclose,
  existingLeadId,
  pushUrl,
  isLoadingButton
}) => {
  const { t } = useTranslation();

  const [state, dispatch] = useReducer(reducer, initialState);
  const [errorVehicleDelivery, setErrorVehicleDelivery] = useState(false);
  const [showSecondNumber, setShowSecondNumber] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorFiscalCode, setErrorFiscalCode] = useState(false);
  const [errorVin, setErrorVin] = useState(false);
  //const [showingVehicleData, setShowVehicleData] = useState(false);
  const [loadingCheckBeforeAdd, setLoadingCheckBeforeAdd] = useState();

  const [showConfirmBack, setShowConfirmBack] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();
    const form = new URLSearchParams(
      new FormData(document.getElementById('create-lead-form'))
    )?.toString();
    createLeadB2C({
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email,
      form,
      state
    });
  };

  useEffect(() => {
    return () => {
      resetCheckData();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetCheckData]);

  useEffect(() => {
    if (
      state.vehicleDelivery &&
      !validator(RegexpType.VEHICHLEDELIVERY, state.vehicleDelivery)
    ) {
      setErrorVehicleDelivery(true);
    } else {
      setErrorVehicleDelivery(false);
    }
  }, [state.vehicleDelivery]);

  useEffect(() => {
    if (state.vin && state.vin.length !== 17) {
      setErrorVin(true);
    } else {
      setErrorVin(false);
    }
  }, [state.vin]);

  useEffect(() => {
    if (state.email) {
      if (!validator(RegexpType.EMAIL, state.email)) {
        setErrorEmail(true);
      } else {
        setErrorEmail(false);
      }
    }
  }, [state.email]);

  useEffect(() => {
    if (
      state.fiscalCode &&
      !validator(RegexpType.FISCAL_CODE, state.fiscalCode)
    ) {
      setErrorFiscalCode(true);
    } else {
      setErrorFiscalCode(false);
    }
  }, [state.fiscalCode]);

  const isDisabled = () =>
    !state.privacyChecked ||
    !state.firstName ||
    !state.lastName ||
    !state.email ||
    !state.prefix ||
    !state.phoneNumber ||
    !state.street ||
    !state.zip ||
    !state.city ||
    !state.carBrand ||
    errorFiscalCode ||
    errorEmail ||
    errorVehicleDelivery ||
    errorCheckAPI ||
    !state.productInterest ||
    (state.productInterest || []).length < 1 ||
    errorVin;
    

  useEffect(() => {
    if (
      state.firstName.length !== 0 &&
      state.lastName.length !== 0 &&
      state.email.length !== 0 &&
      document.activeElement.id !== 'first_name' &&
      document.activeElement.id !== 'last_name' &&
      document.activeElement.id !== 'email' &&
      !errorCheckAPI &&
      !errorEmail &&
      !checkWasDone
    ) {
      if (!isLoading) {
        checkLeadCreation({
          firstName: state.firstName,
          lastName: state.lastName,
          email: state.email
        });
      }
    }
  }, [
    checkLeadCreation,
    state,
    state.firstName,
    state.lastName,
    state.email,
    isLoading,
    errorCheckAPI,
    errorEmail,
    checkWasDone
  ]);

  useEffect(() => {
    if (errorCheckAPI) {
      const firstNameField = document.getElementById('first_row');
      if (firstNameField) {
        firstNameField.scrollIntoView();
      }
    }
  }, [errorCheckAPI]);

  const loadCorrectIcon = () => {
    if (
      state.firstName.length !== 0 &&
      state.lastName.length !== 0 &&
      state.email.length !== 0 &&
      !errorEmail
    ) {
      if (isLoading) {
        return <SpinnerIcon icon={spinnerIcon} />;
      } else {
        if (errorCheckAPI)
          return (
            <Icon
              type="icon-exclamation"
              color={theme().colors.statusRed}
              size={24}
            />
          );
        else if (!errorCheckAPI && checkWasDone)
          return (
            <Icon
              type="icon-icon-success"
              color={theme().colors.aquamarine}
              size={24}
            />
          );
      }
    }
    return <></>;
  };

  const addRef = useRef();
  const remRef = useRef();

  const [addWidth, setAddWidth] = useState(0);
  const [remWidth, setRemWidth] = useState(0);

  useEffect(()=> {
    setLoadingCheckBeforeAdd(isLoadingButton);
  }, [isLoadingButton])

  useLayoutEffect(() => {
    if (addRef.current !== null && addRef.current) {
      setAddWidth(addRef.current.offsetWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t('add_new_lead')]);

  useLayoutEffect(() => {
    if (showSecondNumber && remWidth === 0) {
      if (remRef.current !== null && remRef.current) {
        setRemWidth(remRef.current.offsetWidth);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t('add_new_lead'), showSecondNumber]);

  const loadB2CForm = () => {
    return (
      <>
        <TitleContainer>
          <GoBackContainer>
            <Icon
              type="icon-back"
              size="20"
              color={theme().colors.aquamarine}
              onClick={() => setShowConfirmBack(true)}
            />
          </GoBackContainer>
          <MainFont type="createAccountHeaders">
            {t('add_new_lead')} {t('private')}
          </MainFont>
        </TitleContainer>
        <CreateLeadForm id="create-lead-form" target="invisible">
          <MaxHeightBox>
            <MainFont type="description" id="customer_info_title">
              {t('customer_info')}
            </MainFont>
            <Row split={'1/2'} id="first_row">
              <Input
                id="first_name"
                name="first_name"
                type="text"
                placeholder={`${t('name')}*`}
                variant={'editaccountdata'}
                value={state.firstName}
                status={errorCheckAPI ? 'invalid' : ''}
                onChange={e => {
                  dispatch({
                    type: 'set_name',
                    payload: e.currentTarget.value
                  });
                  if (errorCheckAPI) {
                    resetCheckData();
                  }
                }}
                icon={loadCorrectIcon()}
              />
              <Input
                id="last_name"
                name="last_name"
                type="text"
                placeholder={`${t('surname')}*`}
                variant={'editaccountdata'}
                value={state.lastName}
                status={errorCheckAPI ? 'invalid' : ''}
                onChange={e => {
                  dispatch({
                    type: 'set_last_name',
                    payload: e.currentTarget.value
                  });
                  if (errorCheckAPI) {
                    resetCheckData();
                  }
                }}
                icon={loadCorrectIcon()}
              />
            </Row>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder={`${t('email_placeholder')}*`}
              variant="editaccountdata"
              //status={state.name === '' && 'empty'}
              value={state.email}
              status={errorCheckAPI || errorEmail ? 'invalid' : ''}
              onChange={e => {
                dispatch({
                  type: 'set_email',
                  payload: e.currentTarget.value
                });
                if (errorCheckAPI) {
                  resetCheckData();
                }
              }}
              icon={loadCorrectIcon()}
            />
            {existingLead(errorCheckAPI, existingLeadId, pushUrl, t)}
            {errorEmail && (
              <div>
                <MainFont type="errorLabel">{t('invalid_email')}</MainFont>
              </div>
            )}
            <Input
              id="fiscal_code_id"
              name="fiscal_code_id"
              type="text"
              placeholder={`${t('fiscal_code')}`}
              variant="editaccountdata"
              status={errorFiscalCode ? 'invalid' : ''}
              value={state.fiscalCode}
              onChange={e =>
                dispatch({
                  type: 'set_fiscal_code',
                  payload: e.currentTarget.value
                })
              }
            />
            <PhoneSection
              showSecondNumber={showSecondNumber}
              addWidth={addWidth}
            >
              <DropDown
                type="tel"
                options={phonePrefixesSalesforce}
                onChange={selection => {
                  dispatch({
                    type: 'set_phone_number_prefix',
                    payload: selection.value
                  });
                }}
                placeholder={`${t('prefix')}*`}
                variant="editaccountdata"
                detachedOptions
                noMinWidth
              />
              <Input
                type="tel"
                placeholder={`${t('phone_number')}*`}
                status={state.phoneNumber === '' && 'empty'}
                variant="editaccountdata"
                value={state.phoneNumber}
                onChange={e =>
                  dispatch({
                    type: 'set_phone_number_part',
                    payload: e.currentTarget.value
                  })
                }
                id="phone"
                name="phone"
                phoneSection
              />
              {!showSecondNumber && (
                <AddPhone
                  className="addField"
                  onClick={() => setShowSecondNumber(true)}
                >
                  <Icon
                    type="icon-add"
                    color={theme().colors.aquamarine}
                    size={16}
                  />
                  <div ref={addRef}>
                    <MainFont type="addPhoneNumber">{t('add')}</MainFont>
                  </div>
                </AddPhone>
              )}
            </PhoneSection>
            {showSecondNumber && (
              <PhoneSection remWidth={remWidth}>
                <DropDown
                  type="tel"
                  options={phonePrefixesSalesforce}
                  onChange={selection => {
                    dispatch({
                      type: 'set_phone_number_prefix2',
                      payload: selection.value
                    });
                  }}
                  variant="editaccountdata"
                  detachedOptions
                  noMinWidth
                  placeholder={t('prefix')}
                />
                <Input
                  type="tel"
                  placeholder={`${t('phone_number')}`}
                  status={state.phoneNumber2 === '' && 'empty'}
                  variant="editaccountdata"
                  value={state.phoneNumber2}
                  onChange={e =>
                    dispatch({
                      type: 'set_phone_number_part_2',
                      payload: e.currentTarget.value
                    })
                  }
                  id="mobile"
                  name="mobile"
                  phoneSection
                />

                <AddPhone
                  onClick={() => setShowSecondNumber(false)}
                  className="remField"
                >
                  <Icon
                    type="icon-bin"
                    color={theme().colors.aquamarine}
                    size={16}
                  />
                  <div ref={remRef}>
                    <MainFont type="addPhoneNumber">{t('delete')}</MainFont>
                  </div>
                </AddPhone>
              </PhoneSection>
            )}
            <Input
              id="street"
              name="street"
              type="text"
              placeholder={`${t('address')}*`}
              variant="editaccountdata"
              rows={1}
              value={state.street}
              onChange={e =>
                dispatch({
                  type: 'set_street',
                  payload: e.currentTarget.value
                })
              }
            />
            <Row split="2/3">
              <Input
                id="city"
                name="city"
                type="text"
                maxlength={80}
                placeholder={`${t('city')}*`}
                variant="editaccountdata"
                value={state.city}
                status={state.city === '' && 'empty'}
                onChange={e =>
                  dispatch({
                    type: 'set_city',
                    payload: e.currentTarget.value
                  })
                }
              />
              <Input
                id="zip"
                name="zip"
                type="text"
                placeholder={`${t('zip')}*`}
                variant="editaccountdata"
                value={state.zip}
                onChange={e =>
                  dispatch({
                    type: 'set_zip',
                    payload: e.currentTarget.value
                  })
                }
              />
            </Row>
            {DropDownSelectPreference(dispatch, t)}
            <VehicleSection>
              <MainFont type="description">{`${t('vehicle_info')}`}</MainFont>

              <VehicleContent isOpen>
                <Row noFlex>
                  <DropDown
                    options={brandsVehicle()}
                    onChange={selection => {
                      dispatch({
                        type: 'set_car_brand',
                        payload: selection
                      });
                    }}
                    detachedOptions
                    variant="editaccountdata"
                    placeholder={`${t('car_brand')}*`}
                  />
                </Row>

                <Input
                  id="vehicle_type"
                  name="vehicle_type"
                  type="text"
                  placeholder={`${t('car_model')}`}
                  variant="editaccountdata"
                  //status={state.name === '' && 'empty'}
                  value={state.typeOfVehicle}
                  onChange={e =>
                    dispatch({
                      type: 'set_type_of_vehicle',
                      payload: e.currentTarget.value
                    })
                  }
                />
                <Input
                  id="vehicle_delivery"
                  name="vehicle_delivery"
                  type="text"
                  placeholder={`${t('vehicle_delivery_date')}`}
                  variant="editaccountdata"
                  status={errorVehicleDelivery ? 'invalid' : ''}
                  value={state.vehicleDelivery}
                  onChange={e =>
                    dispatch({
                      type: 'set_vehicle_delivery',
                      payload: e.currentTarget.value
                    })
                  }
                />
                <Input
                  id="vin_field"
                  name="vin_field"
                  type="text"
                  placeholder={`${t('vin')}`}
                  variant="editaccountdata"
                  value={state.vin}
                  onChange={e =>
                    dispatch({
                      type: 'set_vin',
                      payload: e.currentTarget.value
                    })
                  }
                  status={errorVin ? 'invalid' : ''}
                />
                {errorVin && (
                  <div>
                    <MainFont type="errorLabel">{t('error_vin')}</MainFont>
                  </div>
                )}
              </VehicleContent>
            </VehicleSection>
            <Textarea
              id="notes_field"
              name="notes_field"
              placeholder={t('notes')}
              variant="form"
              maxLength={255}
              value={state.notes}
              onChange={e =>
                dispatch({
                  type: 'set_notes',
                  payload: e.currentTarget.value?.substring(0, 255)
                })
              }
            />
            {state.notes.length >= 255 && (
              <div>
                <MainFont>{t('invalid_note_length')}</MainFont>
              </div>
            )}
            <Row
              onClick={() => {
                dispatch({
                  type: 'set_checkbox',
                  payload: !state.privacyChecked
                });
              }}
              clickable
            >
              <Checkbox checked={state.privacyChecked} />
              <MainFont>{t('privacy_policy_label')}</MainFont>
            </Row>
          </MaxHeightBox>
          <DownloadRow marginTop="20">
            <DownloadSection>
              <a
                href={loadCorrectPdf()}
                target="_blank"
                rel="noopener noreferrer"
                download="Leaflet_ePro"
              >
                <Icon
                  type="icon-download1"
                  color={theme().colors.mainBlue}
                  size={14}
                />
                <MainFont>{t('download_brochure')}</MainFont>
              </a>
            </DownloadSection>
            <DownloadSection>
              <a
                href={loadCorrectDoc()}
                target="_blank"
                rel="noopener noreferrer"
                download="pdf-test"
              >
                <Icon
                  type="icon-download1"
                  color={theme().colors.mainBlue}
                  size={14}
                />
                <MainFont>{t('privacy_template')}</MainFont>
              </a>
            </DownloadSection>
          </DownloadRow>
          {loadingCheckBeforeAdd ? (
            <AcceptButtonContainer
              id="button-container"
              onClick={e => e.preventDefault()}
            >
              <Button variant="accept-button" noPadding>
                <SpinnerIcon icon={spinnerIconWhite} marginRight={11} />
                <MainFont type="addAccountLabels">{t('loading')}</MainFont>
              </Button>
            </AcceptButtonContainer>
          ) : (
            <AcceptButtonContainer>
              <Button
                variant="accept-button"
                onClick={e => {
                  
                  handleSubmit(e);
                }}
                disabled={isDisabled()}
              >
                <MainFont type="addAccountLabels">{t('create')}</MainFont>
              </Button>
            </AcceptButtonContainer>
          )}
        </CreateLeadForm>
      </>
    );
  };

  return (
    <CreateContainer>
      {showConfirmBack ? (
        <CloseLeadCreation
          leadClose={resetLeadType}
          reloadCreate={() => setShowConfirmBack(false)}
        />
      ) : (
        loadB2CForm()
      )}
    </CreateContainer>
  );
};

CreateLeadB2C.propTypes = {
  resetLeadType: PropTypes.func,
  createLeadB2C: PropTypes.func,
  errorCheckAPI: PropTypes.string,
  checkLeadCreation: PropTypes.func,
  resetCheckData: PropTypes.func,
  callbackOnclose: PropTypes.func,
  checkWasDone: PropTypes.bool,
  existingLeadId: PropTypes.string,
  pushUrl: PropTypes.func
};

export default connect(
  state => ({
    companyCode: state?.authentication?.accountInfo?.companyCode,
    cognitoId: state?.authentication?.accountInfo?.cognitoId,
    companyDesc: state?.authentication?.accountInfo?.companyDesc,
    isLoading: state?.lead?.isLoadingCheck,
    errorCheckAPI: state?.lead?.errorCheckAPI,
    checkWasDone: state?.lead?.checkWasDone,
    existingLeadId: state?.lead?.existingLeadId,
    isLoadingButton: state?.lead?.isLoadingButton
  }),
  dispatch => ({
    createLeadB2C: payload =>
      dispatch({ type: CREATE_LEAD_B2C._REQUEST, payload }),
    checkLeadCreation: payload =>
      dispatch({ type: CHECK_LEAD_CREATION._REQUEST, payload }),
    resetCheckData: () => dispatch(RESET_CHECK_DATA()),
    pushUrl: url => dispatch(push(url))
  })
)(CreateLeadB2C);
